import type React from "react";
import Layout from "../../../components/site/Layout/Layout";
import MainVisual from "./components/MainVisual";
import About from "./components/About";
import Features from "./components/Features";
import Events from "./components/Events";
import LearningThemes from "./components/LearningThemes";
import RecommendedFor from "./components/RecommendedFor";
import Flow from "./components/Flow";
import CTA from "./components/CTA";

const HomePage: React.FC = () => {
	return (
		<Layout>
			<MainVisual />
			<About />
			<Features />
			<Events />
			<LearningThemes />
			<RecommendedFor />
			<Flow />
			<CTA />
		</Layout>
	);
};

export default HomePage;
